// Project: GSSC Pilot Front-end
// Filename: router.js
// Copyright European Space Agency, 2020
// This file is part of the source code package for contract PO 5001024866
// No part of the package, including this file, may be copied, modified,
// propagated, or distributed without prior approval by ESA.
import Vue from 'vue';
import Router from 'vue-router';
import Register from './views/Register.vue';
import Assets from './views/Assets.vue';
import Admin from './views/Admin.vue';
import Datasets from './views/Datasets.vue';
import Filters from './views/Filters.vue';
import Datalabs from './views/Datalabs.vue';
import Lab from './views/Lab.vue';
import Files from './views/Files.vue';
import Help from './views/Help.vue';
import store from './store';

Vue.use(Router);

const beforeEnterFunc = (to, from, next) => {
  console.log('beforeEnterFunc');
  const token = localStorage.getItem('token');
  if (store.state.token || token) {
    console.log('TOKEN IS, >>', store.state.token, '<<', '>>', token, '<<');
    next();
  } else {
    next('/');
  }
};

const router = new Router({
  // to integrate with wordpress, easiest to use hash mode
  mode: 'history',
  base: process.env.BASE_URL,
  // scrollBehavior() {
  //   // return { x: 0, y: 0 };
  // },
  routes: [
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: { requiresAuth: false }
      // component: () => import('./views/Login.vue'),
    },
    {
      path: '/help',
      name: 'help',
      component: Help,
      meta: { requiresAuth: false }
    },
    {
      path: '/',
      name: 'assets',
      component: Assets,
      meta: { requiresAuth: false }
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "auth" */ './views/Assets.vue'),
    },
    {
      path: '/datasets',
      name: 'datasets',
      component: Datasets,
      meta: { requiresAuth: false }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      beforeEnter: beforeEnterFunc,
      meta: { requiresAuth: true }
    },
    {
      path: '/filters',
      name: 'filters',
      component: Filters,
      beforeEnter: beforeEnterFunc,
      meta: { requiresAuth: true }
    },
    {
      path: '/datalabs',
      name: 'datalabs',
      component: Datalabs,
      meta: { requiresAuth: false }
    },
    {
      path: '/lab/:id',
      name: 'lab',
      component: Lab,
      props: true,
      beforeEnter: beforeEnterFunc,
      meta: { requiresAuth: true }
    },
    {
      path: '/files',
      name: 'files',
      component: Files,
      beforeEnter: beforeEnterFunc,
      meta: { requiresAuth: true }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
});

// error handler solve issue of unnecessary "NavigationDuplicated error"
const onError = e => {
  // avoid NavigationDuplicated
  if (e.name !== 'NavigationDuplicated') throw e;
};

// keep original function
const _push = router.__proto__.push;
// then override it
router.__proto__.push = function push(...args) {
  try {
    const op = _push.call(this, ...args);
    if (op instanceof Promise) op.catch(onError);
    return op;
  } catch (e) {
    onError(e);
  }
};

export default router;
